// LandingRedirect — protected-root element that redirects via
// landingForPermissions(perms). Assumes `<ProtectedRoute>` guarantees `user`
// is hydrated by the time this renders.
import { Navigate } from 'react-router';
import { useAuthStore } from '../stores/auth.js';
import { landingForUser } from './menu.js';

export function LandingRedirect() {
  const user = useAuthStore((s) => s.user);
  const permissions = useAuthStore((s) => s.permissions);
  if (!user) {
    // Defense-in-depth: ProtectedRoute should have redirected to /login
    // before we render. If this throws, the invariant is broken upstream
    // and silently landing a logist somewhere would mask the bug.
    throw new Error('LandingRedirect reached without authenticated user');
  }
  return <Navigate replace to={landingForUser(user, permissions)} />;
}
